import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';

export class Safe extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Safe</Popover.Title>
                <Popover.Content>
                    <img src="https://res.cloudinary.com/dqykhzxtl/image/upload/v1603274935/virtual-time-travel/Safe_ubgt1x.jpg" className="popover-images" alt="Safe Clue" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Safe Clue" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default Safe
